import React from 'react';
import { LANDING_PAGE } from 'config/types/prop';
import withStyles from 'isomorphic-style-loader/withStyles';
import ContentList from 'components/contentList';
import ThemeProvider from 'components/hoc/themeProvider';
import ShowMoreButton from 'components/showMoreButton';

import useAccessibilityFocusLastAfterLoading from 'hooks/useAccessibilityFocusLastAfterLoading';

import styles from './homepage.css';

const Homepage = ({
  relatedItems,
  loadingMore,
  onLoadMore,
  pagination: { hasMore },
}) => {
  const handleFocus = useAccessibilityFocusLastAfterLoading({ loading: loadingMore });
  const showLoadMore = hasMore || loadingMore;

  // Sequences of two-up and three-up sections.
  // If more articles can be loaded, only renders complete rows,
  // Otherwise, the last row may be incomplete.
  const feedSequences = hasMore ? [
    [relatedItems.slice(0, 2), relatedItems.slice(2, 8)],
    [relatedItems.slice(8, 10), relatedItems.slice(10, -1)],
  ] : [
    [relatedItems.slice(0, 2), relatedItems.slice(2, 8)],
    [relatedItems.slice(8, 10), relatedItems.slice(10)],
  ];

  return (
    <div className={styles.wrapper}>
      <section className={styles.content}>
        <div className={styles.latest}>
          {/* eslint-disable react/no-array-index-key */}
          {feedSequences.map((sequence, idx) => (
            <div className={styles.latestContent} key={idx}>
              <div className={styles.twoUpContainer}>
                <ThemeProvider themes={{
                  DefaultListViewItem: 'twoUp',
                  ContentList: 'twoUp',
                }}
                >
                  <ContentList
                    onFocus={handleFocus}
                    items={sequence[0]}
                  />
                </ThemeProvider>
              </div>
              <ThemeProvider themes={{
                DefaultListViewItem: 'threeUp',
                ContentList: 'threeUp',
              }}
              >
                <ContentList
                  onFocus={handleFocus}
                  items={sequence[1]}
                  interstitials={[
                    {
                      frequency: 3,
                      count: Infinity,
                      content: <div className={styles.divider} />,
                    },
                  ]}
                />
              </ThemeProvider>
            </div>
          ))}
        </div>
        {/* eslint-enable */}
        {showLoadMore &&
          <ShowMoreButton
            onClick={onLoadMore}
            disabled={loadingMore}
            loading={loadingMore}
          />
        }
      </section>
    </div>
  );
};

Homepage.propTypes = LANDING_PAGE;

export default withStyles(styles)(Homepage);
